const { NIMBUS_DATA_TYPES } = require('../nimbus-data-types');

module.exports = {
  displayName: 'Transporter Change Truck Type',
  description: 'Change truck type',
  sortOrder: 1,
  name: 'transporter_change_truck_type',
  documentKey: 'transporter_change_truck_type',
  values: {
    transporter_change_truck_type: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: false,
      displayName: 'transporter_change_truck_type',
      documentKey: 'transporter_change_truck_type',
    },
  },
};
